module.exports = __webpack_public_path__ + "img/background.5887d791.jpg";